import { SEATS_RECOMMENDATION_SHOWN } from '../../../../cache';
export const getSeatsRecommendationLSKey = (orderId, segmentId) => `${SEATS_RECOMMENDATION_SHOWN}_${orderId}_${segmentId || 'ALL'}`;
